// extracted by mini-css-extract-plugin
export var fileUpload = "_i0-1";
export var modalButton = "_i0-0";